import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../store/hooks';
import { Form } from 'react-bootstrap';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import {type  BrandModels } from '../../../../store/INV/Brands/BrandModels';
import { updateBrand } from '../../../../store/INV/Brands/BrandSlice';
import { BrandSchema } from '../../../ValidationForm/validationSchema';

interface Props {
  data: BrandModels;
}

const Update = ({ data }: Props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: {
      name: data.name ?? '',
      name2: data.name2 ?? '',
      description: data.description ?? ''
    },
    validationSchema: BrandSchema(t),

    enableReinitialize: true,

    onSubmit: values => {
      dispatch(
        updateBrand({
          id: data.id,
          name: values.name,
          name2: values.name2,
          description: values.description
        })
      )
        .unwrap()
        .then(res => {
          if (res.succeeded === true) {
            formik.resetForm();
            CustomAlert({ action: 'Edit' });
            formik.setSubmitting(false);
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error' });
          }
        })
        .catch(error => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  //____________________________

  return (
    <>
      <Form onSubmit={formik.handleSubmit}>
        <div className='row mb-3'>
          <div className='col-lg-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('LocalName')}</label>
              <Form.Control
                className='form-control fw-bold'
                type='text'
                autoComplete='off'
                name='name2'
                onChange={formik.handleChange}
                value={formik.values.name2}
                isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
              />
              <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
            </div>
          </div>

          <div className='col-lg-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('GlobalName')}</label>
              <Form.Control
                className='form-control fw-bold'
                type='text'
                autoComplete='off'
                name='name'
                onChange={formik.handleChange}
                value={formik.values.name}
                isInvalid={!!(formik.touched.name && formik.errors.name)}
              />
              <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
            </div>
          </div>

          <div className='col-lg-12'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Description')}</label>
              <Form.Control
                className='form-control fw-bold'
                type='text'
                autoComplete='off'
                name='description'
                onChange={formik.handleChange}
                value={formik.values.description}
                isInvalid={!!(formik.touched.description && formik.errors.description)}
              />
              <Form.Control.Feedback type='invalid'>
                {formik.errors.description}
              </Form.Control.Feedback>
            </div>
          </div>
        </div>

        <div className='text-center'>
          <div className='d-flex justify-content-between gap-2'>
            <button
              disabled={formik.isSubmitting}
              type='submit'
              className='btn btn-lg btn-theme mb-1 w-100'
            >
              {formik.isSubmitting ? (
                <div className='spinner-border spinner-border-sm me-2'></div>
              ) : (
                <i className='fas fa-save fa-lg fa-fw me-2'></i>
              )}
              {t('Save')}
            </button>
            <button
              type='button'
              className='btn btn-lg  btn-default mb-1 w-100'
              data-bs-dismiss='modal'
              id='closeModalJob'
            >
              <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
            </button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default Update;
